import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import '../Login/Login.css';

// Request a password-reset email. The backend always responds the same way
// whether or not the account exists, so this screen shows the same confirmation
// regardless — it never reveals which usernames/emails are registered.
const ForgotPasswordScreen = () => {
  const navigate = useNavigate();

  const [identifier, setIdentifier] = React.useState({ value: '', error: '' });
  const [submitting, setSubmitting] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (identifier.value.trim() === '') {
      setIdentifier({ ...identifier, error: 'Enter your username or email' });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post('/api/auth/forgot-password', { identifier: identifier.value.trim() });
    } catch (err) {
      // Deliberately ignored — we show the same confirmation either way so the
      // page can't be used to probe which accounts exist.
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  };

  return (
    <div className='loginContainer' style={{ backgroundImage: 'url(/assets/login-bg.jpg)' }}>
      <div className='blue_container' />
      <div className='login_form_container'>
        <div className='login_form_content'>
          <div className='login_form'>
            <h1 className='login_form_heading'>Reset your password</h1>
            {sent ? (
              <div>
                <p className='auth_helper_text'>
                  If an account matches that username or email, we've sent a link to reset
                  the password. The link expires in 1 hour.
                </p>
                <p className='auth_helper_text'>
                  Didn't get it? Check your spam folder, or contact your administrator.
                </p>
                <Button label='Back to login' style={{ alignSelf: 'flex-start' }}
                  onClick={() => navigate('/login')} />
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <p className='auth_helper_text'>
                  Enter your username or email and we'll send you a link to choose a new password.
                </p>
                <TextInput
                  label='Username or email'
                  icon='user'
                  placeholder='Username or email'
                  value={identifier.value}
                  autoFocus
                  onChange={(ev) => setIdentifier({ value: ev.target.value })}
                  onKeyDown={(ev) => { if (ev.key === 'Enter') handleSubmit(ev); }}
                  errorMessage={identifier.error}
                />
                <Button
                  type='submit'
                  label={submitting ? 'Sending…' : 'Send reset link'}
                  disabled={submitting}
                  style={{ alignSelf: 'flex-start' }}
                  onClick={handleSubmit}
                />
                <button type='button' className='auth_back_link' onClick={() => navigate('/login')}>
                  Back to login
                </button>
              </form>
            )}
          </div>

          <div className='logo_container'>
            <img src='/assets/logo-new.png' alt='Frontline Logo' />
          </div>
        </div>
        <p className='powered_container'>
          Powered By
          <span>Watcher</span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
